import $ from "jquery"
import Vue from 'vue'
import Vuex from 'vuex'
import money from 'v-money'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueTheMask from 'vue-the-mask'
import datePicker from 'vue-bootstrap-datetimepicker'
import App from './App.vue'//o arquivo com o carregamento inicial da app
import router from './router'//importa o arquivo de rotas
import store from './store/store.js'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery-confirm/css/jquery-confirm.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import VueToastr from "vue-toastr"
import cors from 'cors'
import VueSweetalert2 from "vue-sweetalert2"
import Swal from "sweetalert2/dist/sweetalert2.js"
import "@fontsource/nunito";
import 'select2';
import 'select2/dist/css/select2.css'
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'
import 'bootstrap-select/dist/js/bootstrap-select'
import 'bootstrap-select/dist/css/bootstrap-select.css'
import "sweetalert2/dist/sweetalert2.min.css"
import css from './css/p_style.css'
import cssr from './css/style.css'
import cssjv from './css/jsonview.css'

import { Cropper } from 'vue-advanced-cropper' 
import 'vue-advanced-cropper/dist/style.css';


//adicionei pra tentar resolver o problema dos ícones de ordenação das tabelas
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faDumbbell } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'	
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import excel from 'vue-excel-export'
import VueQuagga from 'vue-quaggajs'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import VueCkeditor from 'vue-ckeditor5'
import VueSkeletonLoader from 'skeleton-loader-vue';

import VModal from 'vue-js-modal'
Vue.use(VModal, {  })

const options = {
  editors: {
    classic: ClassicEditor,
  },
  name: 'ckeditor',
  toolbar: [
    'bold',
    'italic',
  ],
}
 
Vue.use(VueCkeditor.plugin, options);

library.add(faUserSecret, faDumbbell);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueViewer)
VueViewer.setDefaults({
    inline: true, 
    button: true, 
    navbar: true, 
    title: false, 
    toolbar: true, 
    tooltip: false, 
    movable: true, 
    zoomable: true, 
    rotatable: true, 
    scalable: true, 
    transition: true, 
    fullscreen: true, 
    keyboard: true
})
//////////////////////////////////////////////////////////////////////////////

window.$ = $
require('jquery-confirm')
Vue.use(Vuex)
Vue.use(cors)
Vue.use(money, {precision: 4})
Vue.use(VueTheMask)
Vue.use(datePicker)
Vue.use(Loading, {
    color: '#5c8f94',
    loader: 'spinner',
    width: 50,
    height: 50,
    backgroundColor: '#343a40',
    opacity: 0.5,
    zIndex: 1040
})
Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
});
Vue.use(VueSweetalert2)
Vue.use(excel)
Vue.use(VueQuagga)
Vue.component('SkeletonLoaderVue', VueSkeletonLoader);
Vue.component(Cropper.name, Cropper);
//configuração do Toast
var Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  timer: 5000,
  timerProgressBar: true,
  showConfirmButton: false,
  zIndex: 2000
});
//salva a configuração global na palavra "Toast"
window.Toast = Toast;

Vue.config.productionTip = false

new Vue({  
  store,
  router,//carrega o array das rotas do arquivo router.js
  render: h => h(App),
}).$mount('#app')
